export const SalutationTypes = {
  modelKey: 'key',
  selectables: [
    { key: 'app.ownerState.mr', value: 'app.ownerState.mr' },
    { key: 'app.ownerState.mrs', value: 'app.ownerState.mrs' },
  ],
};

export const TitleTypes = {
  modelKey: 'key',
  selectables: [
    { key: 'app.ownerState.dr', value: 'app.ownerState.dr' },
    { key: 'app.ownerState.prof', value: 'app.ownerState.prof' },
    { key: 'app.ownerState.profdr', value: 'app.ownerState.profdr' },
  ],
};



// WEBPACK FOOTER //
// ./src/app/common/ui/userForm/userForm.constants.js